import { makeStyles } from '@material-ui/core'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { COLORS } from 'src/utils/Themes/colors'
import { useEffect, useState } from 'react'
import ViewAllMemberDetails from 'src/components/common/MemberDetails/ViewAllMemberDetails'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import { membersColumns, membersColumnsCEO } from 'src/utils/constants/common'

const MemberDetails = ({
  memberDetailsList,
  isCEO,
  isCompanyPolicy,
  policyId,
  clientIdData,
}) => {
  const classes = useStyles()

  const [isViewAllModalOpen, setIsViewAllModalOpen] = useState(false)

  const getAge = (date) => {
    const birthDate = new Date(date)
    const birthYear = birthDate?.getFullYear()
    const presentDate = new Date()
    const presentYear = presentDate?.getFullYear()
    return presentYear - birthYear
  }

  const showEmpId = () => {
    return isCompanyPolicy || isCEO
  }

  const memberDetailsRow = (item) => {
    return (
      <Accordion>
        <div className={classes.textContainer}>
          {showEmpId() ? (
            <span className={classes.text}>{item?.empId}</span>
          ) : null}
          <span className={classes.text}>{item?.firstName}</span>
          <span className={classes.text}>{getAge(item?.dateOfBirth)}</span>

          <span className={classes.ceoRelationText}>
            {item?.dependents?.length > 0 ? (
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id='relationAccordion'
                className={classes.accordionSummaryStyles}
              >
                {item?.relation} + {item?.dependents?.length}
              </AccordionSummary>
            ) : (
              <AccordionSummary className={classes.selfZeroRow}>
                {item?.relation}
              </AccordionSummary>
            )}
          </span>
        </div>
        <AccordionDetails className={classes.accordionDetails}>
          {item?.dependents?.length &&
            item?.dependents?.map((temp) => (
              <div className='flex' key={`dependent__${temp?.id}`}>
                {showEmpId() ? <span className={classes.text}></span> : null}
                <span className={classes.text}>{temp?.firstName}</span>
                <span className={classes.text}>
                  {getAge(temp?.dateOfBirth)}
                </span>
                <span className={classes.text}>{temp?.relation}</span>
              </div>
            ))}
        </AccordionDetails>
      </Accordion>
    )
  }

  const closeViewAllModal = () => {
    setIsViewAllModalOpen(false)
  }

  useEffect(() => {
    if (isViewAllModalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [isViewAllModalOpen])

  return (
    <>
      <Modal open={isViewAllModalOpen} closeModal={closeViewAllModal}>
        <div className={`${classes.modalRoot} modal-container`}>
          <ViewAllMemberDetails
            closeModal={closeViewAllModal}
            isCEO={isCEO}
            isCompanyPolicy={isCompanyPolicy}
            policyId={policyId}
            clientId={clientIdData}
          />
        </div>
      </Modal>
      <div className={classes.container}>
        <div className={classes.searchDiv}>
          <span className={classes.heading}>Member Details</span>
        </div>

        <div className={classes.memberDetailsContainer}>
          <div className={classes.memberDetailsHeader}>
            {showEmpId()
              ? membersColumnsCEO?.map((column) => {
                  return (
                    <span className={classes.portfolioTableText} key={column}>
                      {column}
                    </span>
                  )
                })
              : membersColumns?.map((column) => {
                  return (
                    <span className={classes.portfolioTableText} key={column}>
                      {column}
                    </span>
                  )
                })}
          </div>
          <div className={classes.memberDetailsValueContainer}>
            {memberDetailsList?.length ? (
              memberDetailsList?.map((memberDetailsListItem) => (
                <div key={`memberDetails__${memberDetailsListItem?.empId}`}>
                  {memberDetailsRow(memberDetailsListItem)}
                </div>
              ))
            ) : (
              <div className='no-data-text'>No Data Available</div>
            )}
          </div>
        </div>
        {showEmpId() ? (
          <div className={classes.viewAllContainer}>
            <span
              className={classes.viewAllText}
              onClick={() => setIsViewAllModalOpen(true)}
            >
              View All
            </span>
          </div>
        ) : null}
        <div></div>
      </div>
    </>
  )
}

export default MemberDetails

const useStyles = makeStyles({
  container: {
    padding: '10px 15px 15px 15px',
  },
  heading: {
    margin: '0px 0px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    textAlign: 'initial',
  },
  text: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '15vw',
    fontSize: '12px',
    paddingLeft: '10px',
    textAlign: 'left',
    marginTop: '15px',
  },
  textContainer: {
    display: 'flex',
    paddingLeft: '10px',
  },
  portfolioTableText: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '15vw',
    marginBottom: '5px',
    marginTop: '5px',
    // textAlign: "left",
    paddingLeft: '15px',
  },
  accordionSummaryStyles: {
    '& .MuiAccordionSummary-content': {
      margin: 0,
      marginTop: '10px !important',
    },
  },
  memberDetailsContainer: {
    border: `1px solid  ${COLORS.BLACK01}`,
    borderRadius: '10px',
    height: '150px',
    overflowY: 'auto',
  },
  memberDetailsHeader: {
    display: 'flex',
    fontSize: '13px',
    textAlign: 'left',
    padding: '0px 5px 0px 5px',
    backgroundColor: COLORS.LIGHT_GREY,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    fontWeight: 'bold',
  },
  memberDetailsValueContainer: {
    fontSize: '12px',
  },
  selfZeroRow: {
    pointerEvents: 'none',
  },
  ceoRelationText: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '15vw',
    fontSize: '12px',
    marginTop: '-7px',
    paddingLeft: '10px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  searchDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: '5px',
  },
  accordionDetails: {
    paddingTop: 0,
  },
  viewAllContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '5px',
  },
  viewAllText: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: COLORS.DARK_PINK,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  modalRoot: {
    width: '60%',
    maxHeight: '90%',
    padding: '20px',
    overflowY: 'auto',
    background: '#fff',
  },
})
